module.exports = __webpack_public_path__ + "img/ercode.314e96cc.png";